(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React, { useCallback } from "react";
import PropTypes from "prop-types";

const DownloadButtonItem = _ref => {
  let {
    option,
    handleItemClick
  } = _ref;
  const handleClick = useCallback(() => {
    handleItemClick(option.value);
  }, [option, handleItemClick]);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    React.createElement("li", {
      onClick: handleClick
    }, option.label)
  );
};

__signature__(DownloadButtonItem, "useCallback{handleClick}");

DownloadButtonItem.propTypes = {
  option: PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  }).isRequired,
  handleItemClick: PropTypes.func.isRequired
};
const _default = DownloadButtonItem;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(DownloadButtonItem, "DownloadButtonItem", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/components/DownloadButton/DownloadButtonItem.jsx");
  reactHotLoader.register(_default, "default", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/components/DownloadButton/DownloadButtonItem.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();